module.exports = __webpack_public_path__ + "static/media/Elephant.12fc8ced.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Elephant.jpg
 ** module id = 431
 ** module chunks = 0
 **/